import { Component } from '@angular/core';
import {BroadcastEventService} from "../shared/services/broadcast.event.service";

@Component({
  selector: 'create-questionnaire',
  templateUrl: './create-questionnaire.component.html',
  styleUrls: ['./create-questionnaire.component.css']
})

export class CreateQuestionnaireComponent {

  show : string = "show";

  previewToggleClicked(noUse : string){
    if(this.show == 'show'){
      this.show = 'hide';
    }else{
      this.show = 'show';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/createQuestionnaire/create-questionnaire.component.ts